<template>
  <div v-if="isShow.isPHShow" class="pg3">
    <Nav @nav="handleNav" :activeNum="3" />
    <div class="pg3-title"></div>
    <div class="pg3-article-title1">
      <img src="./img/pg3-article-title1-inner.png" alt="">
    </div>
    <div class="pg3-article1">
      <div class="vd-wp1">
        <div class="vd-wpp1">
          <div class="sprites"></div>
          <div class="vd-wp1-up">
            <span class="wp1-txt">乐于奉献-张芳林</span>
          </div>
          <vd-player :src="src1" :poster="poster1" />
          <div class="vd-wp1-down"></div>
        </div>
      </div>
      <div class="vd-wp2">
        <div class="vd-wpp2">
          <div class="sprites"></div>
          <div class="vd-wp2-up">
            <span class="wp2-txt">不忘初心-苏远清</span>
          </div>
          <vd-player :src="src2" :poster="poster2" />
          <div class="vd-wp2-down"></div>
        </div>
      </div>
      <div class="vd-wp3">
        <div class="vd-wpp3">
          <div class="sprites"></div>
          <div class="vd-wp3-up">
            <span class="wp3-txt">矢志担当-天眼供电服务队</span>
          </div>
          <vd-player :src="src3" :poster="poster3" />
          <div class="vd-wp3-down"></div>
        </div>
      </div>
    </div>
    <div class="pg3-article-title2">
      <img src="./img/pg3-article-title2-inner.png" alt="">
    </div>
    <div class="pg3-article2">
      <div class="pg3-film-wp">
        <div class="pg3-film-up"></div>
        <div class="pg3-film">
          <img src="./img/pg3-film.jpg" alt="">
        </div>
        <div class="pg3-film-down"></div>
      </div>
    </div>
    <div class="pg3-article-title3">
      <img src="./img/pg3-article-title3-inner.png" alt="">
    </div>
    <div class="pg3-article3">
      <div class="pg3-article-c1"></div>
      <div class="pg3-article-c2"></div>
      <div class="pg3-article-c3"></div>
      <div class="pg3-article-c4"></div>
    </div>
    <div class="bg-bottom">
      <div class="bg-bottom-inner">
        <div class="btn-wp">
          <span class="icon-thumb" @click="vote"></span>
          <span class="btn-num">{{num}}</span>
        </div>
        <p class="btn-desc">点赞</p>
        <div class="btn-back" @click="goBack">返回</div>
      </div>
    </div>
    <toast :toastMsg="msg" :ms="time" :isTrigger="trigger" />
  </div>
</template>

<script>
import Nav from '../../components/navBar/navBar'
import { postData } from '../../assets/util'
import Toast from '../../components/toast/toast'
import vdPlayer from '../../components/vd-player/vdPlayer'

export default {
  name: 'PageThree',
  props: {
    isShow: Object
  },
  components: {
    Nav,
    Toast,
    'vd-player': vdPlayer
  },
  data() {
    return {
      num: 0,
      trigger: false,
      msg: '',
      time: 1500,
      src1: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p3-1.mp4',
      src2: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p3-2.mp4',
      src3: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p3-3.mp4',
      poster1: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p3-1.jpg',
      poster2: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p3-2.jpg',
      poster3: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p3-3.jpg',
    }
  },
  methods: {
    goBack() {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow')
      }, 300)
    },
    handleNav(msg) {
      this.$emit('nextPage', msg);
    },
    notify(msg, time) {
      this.trigger = !this.trigger;
      this.msg = msg || '';
      this.time = time || 1500;
    },
    getNumber() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_articleZan';
      const myData = {articleId: 2};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            let tempNum = parseInt(res.zanNum);
            this.num = tempNum;
          } else {
            const txt = res.msg || '获取失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('获取出错')
        })
    },
    vote() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_zan';
      const myData = {articleId: 2};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            this.notify('点赞成功');
            this.num += 1;
          } else {
            const txt = res.msg || '点赞失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('点赞出错')
        })
    },
  },
  watch: {
    'isShow.isPHShow': function () {
      window.scroll(0, 0);
      setTimeout(() => {
        if (this.isShow.isPHShow) {
          const title = document.querySelector('.vd-wp1');
          const title2 = document.querySelector('.vd-wp2');
          const title3 = document.querySelector('.vd-wp3');
          const sub = title.querySelector('.sprites')
          const sub2 = title2.querySelector('.sprites')
          const sub3 = title3.querySelector('.sprites')
          window.addEventListener('scroll', () => {
            if (this.isShow.isPHShow) {
              const dis = title.getBoundingClientRect().top;
              if (dis < 500) {
                title.classList.add('wp1-play');
                setTimeout(() => {
                  sub.classList.add('hide');
                }, 1000);
              }
              if (dis < 100) {
                title2.classList.add('wp2-play');
                setTimeout(() => {
                  sub2.classList.add('hide');
                }, 1000);
              }
              if (dis < -200) {
                title3.classList.add('wp3-play');
                setTimeout(() => {
                  sub3.classList.add('hide');
                }, 1000);
              }
            }
          })
          title.classList.remove('wp1-play');
          title2.classList.remove('wp2-play');
          title3.classList.remove('wp3-play');
          sub.classList.remove('hide');
          sub2.classList.remove('hide');
          sub3.classList.remove('hide');
        }
      }, 200)
    }
  },
  created() {
    this.getNumber();
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg3 {
  box-sizing: border-box;
  padding-top: 1.875rem /* 30/16 */;
  min-height: 100vh;
  background-color: #012bad;
}
.pg3-title {
  width: 23.4375rem /* 375/16 */;
  height: 21.25/2rem /* 340/16 */;
  .bg('./img/pg3-title.png');
}
.pg3-article-title1 {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 15.3125/2rem /* 245/16 */;
    height: 2.5625/2rem /* 41/16 */;
  }
}
.pg3-article1 {
  position: relative;
  margin: 0 auto;
  width: 42.875/2rem /* 686/16 */;
  height: 167.3125/2rem /* 2677/16 */;
  .bg('./img/pg3-article-bg.png');
  overflow: hidden;
}
.vd-wp1 {
  position: absolute;
  top: 16.5rem;
  left: 50%;
  transform: translateX(-50%);
}
.vd-wp2 {
  position: absolute;
  top: 38rem;
  left: 50%;
  transform: translateX(-50%);
}
.vd-wp3 {
  position: absolute;
  bottom: 9.6rem;
  left: 50%;
  transform: translateX(-50%);
}
.vd-wpp1, .vd-wpp2, .vd-wpp3 {
  position: relative;
}
.sprites {
  position: absolute;
  z-index: 5;
  top: -12.5rem /* 200/16 */;
  left: -3.75rem /* 60/16 */;
  width: 416.66px;
  height: 450px;
  background-image: url('../page-four/img/sprite.png');
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity .1s;
}
.wp1-play {
  .sprites {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .wp1-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.wp2-play {
  .sprites {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .wp2-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.wp3-play {
  .sprites {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .wp3-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.wp1-txt, .wp2-txt, .wp3-txt {
  color: white;
  text-shadow: 0 0 8px white;
  opacity: 0;
  transition: all .3s ease-out 1s;
}
.vd-wp1-up, .vd-wp1-down, .vd-wp2-up, .vd-wp2-down, .vd-wp3-up, .vd-wp3-down {
  width: 300px;
  height: 3.125/2rem /* 50/16 */;
  .bg('../page-three/img/film-wp-part.png');
  color: white;
  text-align: center;
  line-height: 1.5625rem /* 25/16 */;
}
.hide {
  display: none;
}
.pg3-article-title2 {
  margin: .625rem /* 10/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 23.4375/2.2rem /* 375/16 */;
    height: 2.8125/2.2rem /* 45/16 */;
  }
}
.pg3-article2 {
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  width: 42.875/2rem /* 686/16 */;
  height: 60.25/2rem /* 964/16 */;
  .bg('./img/pg3-article2.png');
}
.pg3-film-wp {
  position: absolute;
  bottom: 3.125rem /* 50/16 */;
}
.pg3-film-up, .pg3-film-down {
  width: 41.8125/2rem /* 669/16 */;
  height: 3.125/2rem /* 50/16 */;
  .bg('./img/film-wp-part.png');
  animation: boxTrans 6s linear infinite;
}
.pg3-film {
  width: 41.8125/2rem /* 669/16 */;
  height: 24.4375/2rem /* 391/16 */;
  overflow: hidden;
  img {
    width: 121.9375/2rem /* 1951/16 */;
    height: 24.4375/2rem /* 391/16 */;
    animation: imgTrans 8s linear infinite;
  }
}
.pg3-article-title3 {
  margin: .875rem /* 14/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 22.875/2.2rem /* 366/16 */;
    height: 2.9375/2.2rem /* 47/16 */;
  }
}
.pg3-article3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 2.5rem /* 40/16 */;
  margin: 0 auto;
  margin-bottom: 1.875rem /* 30/16 */;
  width: 42.8125/2rem /* 685/16 */;
  height: 138.4375/2rem /* 2215/16 */;
  .bg('./img/pg3-article3-bg.png');
  .pg3-article-c1 {
    width: 36.625/2rem /* 586/16 */;
    height: 26.375/2rem /* 422/16 */;
    .bg('./img/pg3-article3-c1.png');
  }
  .pg3-article-c2 {
    width: 42.9375/2rem /* 687/16 */;
    height: 35.375/2rem /* 566/16 */;
    margin: 1.25rem /* 20/16 */ 0;
    .bg('./img/pg3-article3-c2.png');
  }
  .pg3-article-c3 {
    width: 36/2rem /* 576/16 */;
    height: 23.4375/2rem /* 375/16 */;
    .bg('./img/pg3-article3-c3.png');
  }
  .pg3-article-c4 {
    width: 42.9375/2rem /* 687/16 */;
    height: 27.875/2rem /* 446/16 */;
    margin-top: 1.25rem /* 20/16 */;
    .bg('./img/pg3-article3-c4.png');
  }
}
.bg-bottom {
  width: 23.4375rem /* 375/16 */;
  height: 43.1875/2rem /* 691/16 */;
  background: linear-gradient(to bottom, #012bad 1%, #5d46ac 40%, #a95ece 99%);
  .bg-bottom-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    .bg('../page-two/img/p2-bottom-bg.png');
  }
}
.btn-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffcb04 1%, #faa711 50%, #fe9c21 100%);
  box-shadow: 0 0 6px 0 #5e50a3;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
.icon-thumb {
  display: inline-block;
  width: 7.125/2rem /* 114/16 */;
  height: 7.25/2rem /* 116/16 */;
  margin-top: .375rem /* 6/16 */;
  .bg('../page-two/img/pg2-thumb.png');
}
.btn-num {
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
}
.btn-desc {
  margin: 1rem 0;
  color: #fff;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
}
.btn-back {
  box-sizing: border-box;
  width: 9.375rem /* 150/16 */;
  border-radius: 1.875rem /* 30/16 */;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
  line-height: 2;
  text-align: center;
  border: 1px solid #fff;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
@keyframes titleAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3663px;
  }
}
@keyframes imgTrans {
  from {
    transform: translate(-66%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes boxTrans {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -41.8125/2rem /* 669/16 */;
  }
}
@keyframes particle {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2500px;
  }
}
</style>
